"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.websiteChatMessageAcceptedResponseSchema = exports.websiteChatMessagesResponseSchema = exports.websiteChatPublicMessageSchema = exports.websiteChatReadRequestSchema = exports.createWebsiteChatMessageRequestSchema = exports.websiteChatSessionSchema = exports.createWebsiteChatSessionRequestSchema = exports.publicWebsiteChatConfigSchema = exports.updateWebsiteChatSettingsRequestSchema = exports.websiteChatSettingsSchema = exports.websiteChatAllowedDomainSchema = exports.websiteChatSlugSchema = void 0;
const zod_1 = require("zod");
const conversation_1 = require("./conversation");
exports.websiteChatSlugSchema = zod_1.z
    .string()
    .trim()
    .min(3)
    .max(80)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
exports.websiteChatAllowedDomainSchema = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .max(253)
    .regex(/^(?:localhost(?::\d{1,5})?|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63})(?::\d{1,5})?$/, "Enter a hostname, optionally followed by a port.");
exports.websiteChatSettingsSchema = zod_1.z.object({
    businessId: zod_1.z.string().uuid(),
    enabled: zod_1.z.boolean(),
    allowedDomains: zod_1.z.array(exports.websiteChatAllowedDomainSchema).max(50),
    displayName: zod_1.z.string().min(1).max(120),
    welcomeMessage: zod_1.z.string().min(1).max(500),
    accentColor: zod_1.z.string().regex(/^#[0-9a-f]{6}$/i),
    defaultAssigneeMembershipId: zod_1.z.string().uuid().nullable(),
    autoReplyEnabled: zod_1.z.boolean(),
    autoReplyMessage: zod_1.z.string().min(1).max(1_000),
    verification: zod_1.z.enum(["NOT_CONFIGURED", "READY"]),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.updateWebsiteChatSettingsRequestSchema = zod_1.z
    .object({
    enabled: zod_1.z.boolean(),
    allowedDomains: zod_1.z.array(exports.websiteChatAllowedDomainSchema).max(50),
    displayName: zod_1.z.string().trim().min(1).max(120),
    welcomeMessage: zod_1.z.string().trim().min(1).max(500),
    accentColor: zod_1.z.string().regex(/^#[0-9a-f]{6}$/i),
    defaultAssigneeMembershipId: zod_1.z.string().uuid().nullable(),
    autoReplyEnabled: zod_1.z.boolean(),
    autoReplyMessage: zod_1.z.string().trim().min(1).max(1_000),
})
    .transform((value) => ({
    ...value,
    allowedDomains: [...new Set(value.allowedDomains)],
}));
exports.publicWebsiteChatConfigSchema = zod_1.z.object({
    enabled: zod_1.z.literal(true),
    displayName: zod_1.z.string().min(1).max(120),
    welcomeMessage: zod_1.z.string().min(1).max(500),
    accentColor: zod_1.z.string().regex(/^#[0-9a-f]{6}$/i),
});
exports.createWebsiteChatSessionRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
    contactName: zod_1.z.string().trim().min(1).max(160).optional(),
    contactEmail: zod_1.z.string().trim().toLowerCase().email().max(320).optional(),
    contactPhone: zod_1.z.string().trim().min(7).max(32).optional(),
    initialMessage: zod_1.z.string().trim().min(1).max(5_000),
    website: zod_1.z.string().max(0).optional(),
});
exports.websiteChatSessionSchema = zod_1.z.object({
    sessionId: zod_1.z.string().uuid(),
    sessionToken: zod_1.z.string().min(32),
    conversationId: conversation_1.conversationIdSchema,
    expiresAt: zod_1.z.string().datetime({ offset: true }),
});
exports.createWebsiteChatMessageRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
    body: zod_1.z.string().trim().min(1).max(5_000),
});
exports.websiteChatReadRequestSchema = zod_1.z.object({
    messageIds: zod_1.z.array(conversation_1.messageIdSchema).min(1).max(250),
});
exports.websiteChatPublicMessageSchema = zod_1.z.object({
    seenAt: zod_1.z.string().datetime({ offset: true }).nullable().optional(),
    id: conversation_1.messageIdSchema,
    direction: zod_1.z.enum(["INBOUND", "OUTBOUND"]),
    body: zod_1.z.string().min(1),
    status: zod_1.z.enum(["SENT", "DELIVERED", "RECEIVED"]),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.websiteChatMessagesResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.websiteChatPublicMessageSchema).max(250),
});
exports.websiteChatMessageAcceptedResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    messageId: conversation_1.messageIdSchema,
});
//# sourceMappingURL=website-chat.js.map